import { gql } from 'graphql-tag';
import { backgroundFragment } from '../background/queries';

export const getUserBackgroundQuery = gql`
  query getUserBackground(
    $pageType: PageTypesType
    $page: Int
    $perPages: Int
  ) {
    user_backgrounds_page_type(
      page_type: $pageType
      page: $page
      per_page: $perPages
    ) {
      ...backgroundDetail
    }
  }
  ${backgroundFragment}
`;

export const getUserClipArtQuery = gql`
  query getUserClipArt($page: Int, $perPages: Int) {
    user_cliparts(page: $page, per_page: $perPages) {
      id
      name
      category
      thumbnail
      large_url
    }
  }
`;
